import styled from 'styled-components';
import { layout, styledUtils } from '@prisjakt/ui-base';

import { Link } from 'react-router-dom';
import RatingComponent from 'src/components/rating';

export const ProductImage = styled.div`
  height: 40px;
  width: 40px;
`;

export const Currency = styled.div`
  font-weight: 600;
`;

export const ProductRating = styled(RatingComponent)``;

export const ProductName = styled.div``;

export const Product = styled(Link)`
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: ${layout.measurements.spacing025} ${layout.measurements.spacing050};
  padding: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing050};
  position: relative;
  align-items: center;

  ${ProductImage} {
    grid-area: 1 / 1 / 3 / 2;
  }

  ${ProductName} {
    grid-area: 1 / 2 / 2 / 4;
  }

  ${ProductRating} {
    grid-area: 2 / 2 / 3 / 3;
  }

  ${Currency} {
    grid-area: 2 / 3 / 3 / 4;
  }

  &::after {
    ${styledUtils.overlay()}
    border-radius: 5px;
    pointer-events: none;
    transition: background-color 150ms ease;
  }

  &:hover {
    &::after {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
`;
